// POS-I183: rules for a password that is being SET. Same list and same function as the API
// (backend/src/common/validators/strong-password.ts); password-rules.spec.ts compares the two.
// Length is counted in BYTES (UTF-8): bcrypt ignores everything after byte 72 and an Urdu letter
// takes 2 to 3 bytes.

export const PASSWORD_MIN_BYTES = 8;
export const PASSWORD_MAX_BYTES = 72;

export const COMMON_PASSWORDS: readonly string[] = [
  '12345678', '123456789', '1234567890', '11111111', '00000000', '87654321', '12341234', '123123123',
  'password', 'password1', 'password12', 'password123', 'password1234', 'passw0rd', 'p@ssw0rd', 'p@ssword',
  'qwerty123', 'qwertyuiop', 'qwerty12', 'qwerty1234', 'asdfghjkl', 'zxcvbnm123', '1q2w3e4r', '1qaz2wsx',
  'abc12345', 'abcd1234', 'abc123456', 'a1b2c3d4', 'admin123', 'admin1234', 'administrator', 'welcome1',
  'welcome123', 'letmein123', 'iloveyou', 'iloveyou1', 'iloveyou123', 'monkey123', 'dragon123', 'football1',
  'baseball1', 'superman1', 'sunshine1', 'princess1', 'shadow123', 'master123', 'login123', 'test1234',
  'pakistan123', 'pakistan1', 'karachi123', 'lahore123', 'islamabad1', 'muhammad123', 'allah123', 'bismillah1',
  'change123', 'default123', 'demo1234', 'pos12345', 'clearring1',
];

const COMMON = new Set(COMMON_PASSWORDS.map((p) => p.toLowerCase()));

export type PasswordProblem = 'rules' | 'common' | null;

function utf8Length(value: string): number {
  return new TextEncoder().encode(value).length;
}

/** The first problem with a new password, or null when it is acceptable. */
export function passwordProblem(password: string, email?: string): PasswordProblem {
  const bytes = utf8Length(password);
  if (bytes < PASSWORD_MIN_BYTES || bytes > PASSWORD_MAX_BYTES) return 'rules';
  if (!/\p{L}/u.test(password) || !/\p{Nd}/u.test(password)) return 'rules';
  const lower = password.toLowerCase();
  if (COMMON.has(lower)) return 'common';
  if (email && email.includes('@')) {
    const local = email.split('@')[0].trim().toLowerCase();
    if (local && lower === local) return 'common';
  }
  return null;
}

/** The two live ticks under the password box. */
export function passwordChecks(password: string, email?: string): { basics: boolean; notCommon: boolean } {
  const problem = passwordProblem(password, email);
  const basics = problem !== 'rules';
  // "Not a common password" is only a meaningful tick once the basics hold
  return { basics, notCommon: basics && problem !== 'common' };
}
